import React, { Component } from "react";
import { Image } from "semantic-ui-react";
import Images from "../../config/images";
import get from 'lodash/get';
import isEqual from 'lodash/isEqual';
import { getSignedUrls } from "../../apiCalls/MainFormRequests";

class JobQueueHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      profileImage: null,
      headerClass: "header-bar"
    };
  }

  async componentDidUpdate(prevProps, prevState) {
    if (!isEqual(get(this.props, "profile.userBasicInfo.displayImage", null), get(prevProps, "profile.userBasicInfo.displayImage", null))) {
      let displayImage = get(this.props, "profile.userBasicInfo.displayImage", null);
      let profileImage = displayImage ? await this.getImage(displayImage) : null;
      this.setState({ profileImage });
    }
    if(!isEqual(get(this.props, "myAccountOpen", null), get(prevProps, "myAccountOpen", null))){
      let headerClass = this.props.myAccountOpen ? "header-bar collapsed accountOpen" : `header-bar accountClosed`;
      this.setState({ headerClass })
    }
  }

  close() {
    const { toggle, toggleModal } = this.props;

    toggleModal("");
    toggle("myAccountOpen", false);
  }

  getImage = async (displayImage) => {
    return new Promise((resolve, reject) => {
      getSignedUrls({ bucket: window._env_.CUSTOMER_MEDIA_BUCKET, files: [displayImage] })
        .then((res) => {
          let url = get(res, "data.eventMessage.urls[0]", null);
          resolve(url);
        })
        .catch((err) => {
          console.error("caught err: ", err);
          resolve(null);
        });
    });
  };

  render() {
    const { myAccountOpen, toggle } = this.props;

    return (
      <div id="kn-hamberger" className={`${this.state.headerClass}`}>
        {!myAccountOpen && <Image id="kn-hamberger-closed" className="menu-icon hamberger" src={Images.menuIcon} name="content" onClick={() => {toggle("myAccountOpen", true)}} />}
        {myAccountOpen && <Image id="kn-hamberger-opened" className="menu-icon hamberger" src={Images.menuIcon} name="close" onClick={() => {this.close();}   } />}
        <img alt="KlearNow" src="/images/KlearNowLogo.png" className={`kx-header-logo ${myAccountOpen ? 'closed' : ""}`} />
        
      </div>
    );
  }
}

export default JobQueueHeader;
